import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context";

/**
 * Fetches a user's equipped marketplace items indexed by slot.
 * Returns `{ nameplate, theme, badge, pet, ... }` where each value is
 * the item record (or null if nothing equipped in that slot).
 * Cached in-memory per userId for the session.
 */
const cache = new Map();

export default function useEquippedItems(userId) {
  const [equipped, setEquipped] = useState(() => cache.get(userId) || {});
  const [loading, setLoading] = useState(!cache.has(userId));

  useEffect(() => {
    if (!userId) { setEquipped({}); setLoading(false); return; }
    let cancelled = false;
    setLoading(true);
    axios.get(`${API}/marketplace-shop/inventory/${encodeURIComponent(userId)}/equipped`)
      .then(r => {
        if (cancelled) return;
        const data = r.data?.equipped || {};
        cache.set(userId, data);
        setEquipped(data);
      })
      .catch(() => { if (!cancelled) setEquipped({}); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [userId]);

  return { equipped, loading };
}

// Expose cache invalidator for post-purchase/post-equip
export function invalidateEquippedCache(userId) {
  if (userId) cache.delete(userId);
  else cache.clear();
}
